import { useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Grid2,
  CircularProgress,
} from "@mui/material";
import styles from "./DevToolsTable.module.scss";
import DeleteOutlinedIcon from "@mui/icons-material/DeleteOutlined";
import { ReactComponent as SftpUser } from "../../../../../../Admin/AdminAssets/svg/SftpUser.svg";
import { CP } from "../../../../../../../Utils/roconConstants";

const DevToolsTable = (props) => {
  const { rows, sftpClick, sites } = props;

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);

  const handleChangePage = (newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const paginatedRows = rows?.slice(
    page * rowsPerPage,
    page * rowsPerPage + rowsPerPage
  );

  const sftpDetails = sites?.sftpDetails;

  return (
    <Grid2>
      <TableContainer className={styles.main}>
        <Grid2 className={styles.display}>
          <Grid2 className={styles.header1}>SFTP Details</Grid2>
          <Grid2 className={styles.header} onClick={sftpClick}>
            {rows?.length >= 5 ? "" : "Create SFTP User"}
          </Grid2>
        </Grid2>

        {sftpDetails ? (
          rows?.length === 0 ? (
            <Grid2 className={styles.noData}>
              <SftpUser className={styles.SftpUser} />
              There are no SFTP users for this environment.
            </Grid2>
          ) : (
            <Table>
              <TableHead className={styles.tableHead}>
                <TableRow className={styles.tablerow}>
                  <TableCell className={styles.tableHeaderText}>Host</TableCell>
                  <TableCell className={styles.tableHeaderText}>
                    User Name
                  </TableCell>
                  <TableCell className={styles.tableHeaderText}>Port</TableCell>
                  <TableCell className={styles.tableHeaderText}>
                    Delete
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {paginatedRows?.map((item, index) => (
                  <TableRow key={index} className={styles.row}>
                    <TableCell className={styles.tableBodyText}>
                      {item.host}
                    </TableCell>
                    <TableCell className={styles.tableBodyText}>
                      {item.name}
                    </TableCell>
                    <TableCell className={styles.tableBodyText}>
                      {item.port}
                    </TableCell>
                    <TableCell
                      className={styles.delete}
                      onClick={() => item.delete()}
                    >
                      <DeleteOutlinedIcon className={styles.deleteIcon} />
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          )
        ) : (
          <Grid2 className={styles.loading}>
            <CircularProgress size={CP.SIZE} className={styles.loadingColor} />
          </Grid2>
        )}
      </TableContainer>
    </Grid2>
  );
};

export default DevToolsTable;
